import React from 'react'
import LayoutLogin from './layout/LayoutLogin';
import LoginUserForm from './login-form/user-login';

const MembersLogin = () => {
    return (
        <LayoutLogin
            loginType={'user'}
        >
            <div className='min-w-full h-[100%] flex flex-col justify-between items-start'>

                <img src={'/assets/admin/header-icon.svg'} className='object-contain h-[45px] mb-5 ml-5' />
                <div className='m-auto'>

                    <h1 className='font-dm_sansbold text-[#101010] text-4xl text-left'>Sign in</h1>
                    <p className='mb-5'>Into your hotel dashboard</p>

                    <LoginUserForm />

                </div>
                <div className='flex flex-row justify-between min-w-full'>
                    <div className='flex items-center '>
                        <div className='cursor-pointer hover:opacity-80'>Terms</div>
                        <span className='px-1 text-black '>•</span>
                        <div className='cursor-pointer hover:opacity-80'>Privacy Policy</div>
                    </div>
                    <div>
                        <p>&copy; All rights reserved.</p>
                    </div>
                </div>
            </div>
        </LayoutLogin>
    )
}

export default MembersLogin;